import { ProduktionsmallQueryResponseDTO } from "~app/common/models/produktionsmall/v2/ProduktionsmallQueryResponseDTO";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ProduktionsmallarTexts } from "~app/features/planera/produktionsmallar/produktionsmallar.texts";
import { IProduktvalRow } from "~app/features/planera/produktval/produktval.models";

export class ProduktionsmallValidation {
    static init(mall: ProduktionsmallQueryResponseDTO,
        valdaproduktrader: IProduktvalRow[],
        existingMallar: ProduktionsmallQueryResponseDTO[],
        isCKMall: boolean): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                expression: () => !(mall.benamning === null || mall.benamning === undefined || mall.benamning.length === 0),
                message: { text: ProduktionsmallarTexts.validation.missingMallnamn },
                model: () => mall.benamning,
                name: "namnRequired"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: () => mall.benamning.length <= 40,
                message: { text: ProduktionsmallarTexts.validation.maxLengthError },
                model: () => mall.benamning,
                name: "maxLengthError"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: () => {
                    const allExceptCurrentOneIfItIsAlreadySaved = existingMallar.filter(m => m.id !== mall.id);
                    const nameTaken = allExceptCurrentOneIfItIsAlreadySaved.some(x => x.benamning.trim().toLowerCase() === mall.benamning.trim().toLowerCase());
                    return !nameTaken;
                },
                message: { text: ProduktionsmallarTexts.validation.namnAlreadyTaken },
                model: () => mall.benamning,
                name: "namnAlreadyTaken"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: () => !(valdaproduktrader === null || valdaproduktrader === undefined || valdaproduktrader.length === 0),
                message: { text: ProduktionsmallarTexts.validation.missingHandelssortiment },
                model: () => valdaproduktrader,
                name: "valdaproduktraderRequired"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: "Uppdragsgivare måste anges" },
                applicable: () => isCKMall,
                model: () => mall.ckLeverantorId,
                name: "uppdragsgivareRequired",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: "Uppdragsgivare får endast finnas på en produktionsmall" },
                expression: (newValue) => {
                    const allExceptCurrentOneIfItIsAlreadySaved = existingMallar.filter(m => m.id !== mall.id);
                    const ckLevTaken = allExceptCurrentOneIfItIsAlreadySaved.some(y => y.ckLeverantorId === mall.ckLeverantorId);
                    return !ckLevTaken;
                },
                applicable: () => isCKMall && ObjectUtils.hasValue(mall.ckLeverantorId),
                model: () => mall.ckLeverantorId,
                name: "uppdragsgivareUnique"
            }
        ]);

        return context;
    }
}
